import { Component, ElementRef, forwardRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { FilterableOption } from './ihm-filterable-option.interface';

@Component({
  selector: 'ihm-filterable-select',
  templateUrl: './ihm-filterable-select.component.html',
  styleUrls: ['./ihm-filterable-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => IhmFilterableSelectComponent),
      multi: true
    }
  ]
})
export class IhmFilterableSelectComponent implements OnInit, OnDestroy, ControlValueAccessor {
  private readonly ngUnsubscribe: Subject<void> = new Subject<void>();

  selectAllFilterControl: FormControl;
  selectAllControl: FormControl;

  @Input()
  readonly searchPlaceHolderText: string = 'Search';

  @Input()
  readonly debounceTime: number = 400;

  @Input()
  readonly dropDownValues: FilterableOption[];

  @Input()
  readonly initialSelection: number[] = [];

  @Input()
  readonly showSelectAll: boolean = false;

  @Input()
  readonly showOptionTooltip: boolean = false;

  @Input()
  readonly tooltipDelay: number = 1000;

  filteredValues: FilterableOption[];

  @ViewChild('filterInputElement') filterInputElement: ElementRef;

  propagateChange = (value: any) => {};

  ngOnInit(): void {
    this.selectAllFilterControl = new FormControl('');

    this.selectAllControl = new FormControl(this.initialSelection);
    this.reset();
    this.writeValue(this.initialSelection);

    this.selectAllFilterControl.valueChanges.pipe(debounceTime(this.debounceTime)).subscribe(filterText => {
      if (filterText === '') {
        this.reset();
      } else {
        this.filterValues(filterText);
      }
    });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.unsubscribe();
  }

  reset() {
    this.filteredValues = this.dropDownValues;
    this.selectAllFilterControl.patchValue('', { emitEvent: false });
  }

  onOpen() {
    this.filterInputElement.nativeElement.focus();
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {}

  writeValue(value: any): void {
    if (value) {
      this.propagateChange(value);
    }
  }

  selectAllToggled(options: FilterableOption[]) {
    const optionsIds = options.map(option => Number(option.id));
    this.writeValue(optionsIds);
    this.selectAllControl.patchValue(optionsIds);
  }

  private filterValues(text: string) {
    const lowercaseText: string = text.toLowerCase();
    this.filteredValues = this.dropDownValues.filter(item => item.value.toLowerCase().includes(lowercaseText));
  }
}
